module.exports = __webpack_public_path__ + "static/media/gertner-vinobrani-01.60a9f18a.png";